import React, { useState } from "react";

import Select from "react-select";

import { Modal, ModalBody, ModalHeader, Button, Input, Label, } from "reactstrap";

import { toast } from "react-toastify";

import useFbTokenSetup from "../../Hooks/useFbTokenSetup";

const FbTokenSetupModal = ({ isOpen, toggle, refresh }) => {

  const { loading, pages, userTokens, fetchPages, savePages, extendUserToken, } = useFbTokenSetup();

  const [type, setType] = useState("user");

  const [accessToken, setAccessToken] = useState("");

  const [selectedUserToken, setSelectedUserToken] = useState(null);

  const [selectedPages, setSelectedPages] = useState([]);

  const handleExtend = async () => {

    try {

      const res = await extendUserToken(accessToken);

      toast.success(res?.message);

      refresh?.();

      toggle();

    } catch (err) {

      toast.error(err?.response?.data?.error || err?.message);
    }
  };

  const handleFetchPages = async (option) => {

    setSelectedUserToken(option);

    await fetchPages(option.value);
  };

  const handleSavePages = async () => {

    try {

      await savePages(
        selectedUserToken.value,
        selectedPages.map((p) => p.raw)
      );

      toast.success("Pages Saved Successfully");

      refresh?.();

      toggle();

    } catch (err) {

      toast.error(err?.response?.data?.error || err?.message);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">

      <ModalHeader toggle={toggle}>
        Setup Facebook Token
      </ModalHeader>

      <ModalBody>

        <div className="mb-3">

          <Label>
            Type
          </Label>

          <Input
            type="select"
            value={type}
            onChange={(e) =>
              setType(e.target.value)
            }
          >
            <option value="user">
              User Token
            </option>

            <option value="page">
              Page Token
            </option>

          </Input>

        </div>

        {type === "user" && (
          <>

            <div className="mb-3">

              <Label>
                Paste User Token
              </Label>

              <Input
                type="textarea"
                rows="6"
                value={accessToken}
                onChange={(e) =>
                  setAccessToken(e.target.value)
                }
              />

            </div>

            <Button
              color="primary"
              disabled={loading}
              onClick={handleExtend}
            >
              Save User Token
            </Button>

          </>
        )}

        {type === "page" && (
          <>

            <div className="mb-3">

              <Label>
                Select User Token
              </Label>

              <Select
                options={userTokens.map((u) => ({
                  label: `${u.name} (${u.refId})`,
                  value: u._id,
                }))}
                onChange={handleFetchPages}
              />

            </div>

            {!!pages.length && (
              <div className="mb-3">

                <Label>
                  Select Pages
                </Label>

                <Select
                  isMulti
                  closeMenuOnSelect={false}
                  options={pages.map((p) => ({
                    label: `${p.name} (${p.id})`,
                    value: p.id,
                    raw: p,
                  }))}
                  onChange={setSelectedPages}
                />

              </div>
            )}

            {!!selectedPages.length && (
              <Button
                color="primary"
                disabled={loading}
                onClick={handleSavePages}
              >
                Save Pages
              </Button>
            )}

          </>
        )}

      </ModalBody>

    </Modal>
  );
};

export default FbTokenSetupModal;